/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateModelDto,
  ListWorkflowModelsResult,
  UpdateModelDto,
  WorkflowModelEntity,
} from '../models/index';
import {
    CreateModelDtoFromJSON,
    CreateModelDtoToJSON,
    ListWorkflowModelsResultFromJSON,
    ListWorkflowModelsResultToJSON,
    UpdateModelDtoFromJSON,
    UpdateModelDtoToJSON,
    WorkflowModelEntityFromJSON,
    WorkflowModelEntityToJSON,
} from '../models/index';

export interface ConvertExpressionRequest {
    expressionString: string;
}

export interface CreateWorkflowModelRequest {
    createModelDto: CreateModelDto;
}

export interface DeleteWorkflowModelRequest {
    modelId: string;
}

export interface GetWorkflowModelRequest {
    modelId: string;
}

export interface GetWorkflowModelWithLatestModelHistoryRequest {
    modelId: string;
}

export interface ListModelHistoriesRequest {
    modelId: string;
}

export interface ListWorkflowModelsRequest {
    filter?: string;
    skip?: string;
    take?: string;
}

export interface PublishWorkflowModelRequest {
    modelId: string;
}

export interface SaveWorkflowModelRequest {
    modelId: string;
    updateModelDto: UpdateModelDto;
}

export interface ValidateExpressionRequest {
    expressionJson: string;
}

/**
 * 
 */
export class ModelApi extends runtime.BaseAPI {

    /**
     * 文字列をexpressionに変換します。
     */
    async convertExpressionRaw(requestParameters: ConvertExpressionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['expressionString'] == null) {
            throw new runtime.RequiredError(
                'expressionString',
                'Required parameter "expressionString" was null or undefined when calling convertExpression().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/models/convertExpression/{expressionString}`.replace(`{${"expressionString"}}`, encodeURIComponent(String(requestParameters['expressionString']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 文字列をexpressionに変換します。
     */
    async convertExpression(requestParameters: ConvertExpressionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.convertExpressionRaw(requestParameters, initOverrides);
    }

    /**
     * ワークフローモデルを1件登録する。
     */
    async createWorkflowModelRaw(requestParameters: CreateWorkflowModelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkflowModelEntity>> {
        if (requestParameters['createModelDto'] == null) {
            throw new runtime.RequiredError(
                'createModelDto',
                'Required parameter "createModelDto" was null or undefined when calling createWorkflowModel().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/models`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateModelDtoToJSON(requestParameters['createModelDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkflowModelEntityFromJSON(jsonValue));
    }

    /**
     * ワークフローモデルを1件登録する。
     */
    async createWorkflowModel(requestParameters: CreateWorkflowModelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkflowModelEntity> {
        const response = await this.createWorkflowModelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ワークフローモデルを1件削除する。
     */
    async deleteWorkflowModelRaw(requestParameters: DeleteWorkflowModelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkflowModelEntity>> {
        if (requestParameters['modelId'] == null) {
            throw new runtime.RequiredError(
                'modelId',
                'Required parameter "modelId" was null or undefined when calling deleteWorkflowModel().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/models/{modelId}`.replace(`{${"modelId"}}`, encodeURIComponent(String(requestParameters['modelId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkflowModelEntityFromJSON(jsonValue));
    }

    /**
     * ワークフローモデルを1件削除する。
     */
    async deleteWorkflowModel(requestParameters: DeleteWorkflowModelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkflowModelEntity> {
        const response = await this.deleteWorkflowModelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 公開中のワークフローモデルを1件取得する。公開中のモデルがない場合は、モデル定義は空になる。
     */
    async getWorkflowModelRaw(requestParameters: GetWorkflowModelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkflowModelEntity>> {
        if (requestParameters['modelId'] == null) {
            throw new runtime.RequiredError(
                'modelId',
                'Required parameter "modelId" was null or undefined when calling getWorkflowModel().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/models/{modelId}`.replace(`{${"modelId"}}`, encodeURIComponent(String(requestParameters['modelId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkflowModelEntityFromJSON(jsonValue));
    }

    /**
     * 公開中のワークフローモデルを1件取得する。公開中のモデルがない場合は、モデル定義は空になる。
     */
    async getWorkflowModel(requestParameters: GetWorkflowModelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkflowModelEntity> {
        const response = await this.getWorkflowModelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 編集中のワークフローモデルを1件取得する。
     */
    async getWorkflowModelWithLatestModelHistoryRaw(requestParameters: GetWorkflowModelWithLatestModelHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkflowModelEntity>> {
        if (requestParameters['modelId'] == null) {
            throw new runtime.RequiredError(
                'modelId',
                'Required parameter "modelId" was null or undefined when calling getWorkflowModelWithLatestModelHistory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/models/{modelId}/edit`.replace(`{${"modelId"}}`, encodeURIComponent(String(requestParameters['modelId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkflowModelEntityFromJSON(jsonValue));
    }

    /**
     * 編集中のワークフローモデルを1件取得する。
     */
    async getWorkflowModelWithLatestModelHistory(requestParameters: GetWorkflowModelWithLatestModelHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkflowModelEntity> {
        const response = await this.getWorkflowModelWithLatestModelHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ワークフローモデル履歴を取得する
     */
    async listModelHistoriesRaw(requestParameters: ListModelHistoriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WorkflowModelEntity>>> {
        if (requestParameters['modelId'] == null) {
            throw new runtime.RequiredError(
                'modelId',
                'Required parameter "modelId" was null or undefined when calling listModelHistories().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/models/{modelId}/histories`.replace(`{${"modelId"}}`, encodeURIComponent(String(requestParameters['modelId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WorkflowModelEntityFromJSON));
    }

    /**
     * ワークフローモデル履歴を取得する
     */
    async listModelHistories(requestParameters: ListModelHistoriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WorkflowModelEntity>> {
        const response = await this.listModelHistoriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ワークフローモデル一覧を取得する。
     */
    async listWorkflowModelsRaw(requestParameters: ListWorkflowModelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListWorkflowModelsResult>> {
        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        if (requestParameters['skip'] != null) {
            queryParameters['skip'] = requestParameters['skip'];
        }

        if (requestParameters['take'] != null) {
            queryParameters['take'] = requestParameters['take'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/models`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListWorkflowModelsResultFromJSON(jsonValue));
    }

    /**
     * ワークフローモデル一覧を取得する。
     */
    async listWorkflowModels(requestParameters: ListWorkflowModelsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListWorkflowModelsResult> {
        const response = await this.listWorkflowModelsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ワークフローモデルを1件公開する。
     */
    async publishWorkflowModelRaw(requestParameters: PublishWorkflowModelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkflowModelEntity>> {
        if (requestParameters['modelId'] == null) {
            throw new runtime.RequiredError(
                'modelId',
                'Required parameter "modelId" was null or undefined when calling publishWorkflowModel().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/models/{modelId}/publish`.replace(`{${"modelId"}}`, encodeURIComponent(String(requestParameters['modelId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkflowModelEntityFromJSON(jsonValue));
    }

    /**
     * ワークフローモデルを1件公開する。
     */
    async publishWorkflowModel(requestParameters: PublishWorkflowModelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkflowModelEntity> {
        const response = await this.publishWorkflowModelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ワークフローモデルを1件保存する。
     */
    async saveWorkflowModelRaw(requestParameters: SaveWorkflowModelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkflowModelEntity>> {
        if (requestParameters['modelId'] == null) {
            throw new runtime.RequiredError(
                'modelId',
                'Required parameter "modelId" was null or undefined when calling saveWorkflowModel().'
            );
        }

        if (requestParameters['updateModelDto'] == null) {
            throw new runtime.RequiredError(
                'updateModelDto',
                'Required parameter "updateModelDto" was null or undefined when calling saveWorkflowModel().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/models/{modelId}`.replace(`{${"modelId"}}`, encodeURIComponent(String(requestParameters['modelId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateModelDtoToJSON(requestParameters['updateModelDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkflowModelEntityFromJSON(jsonValue));
    }

    /**
     * ワークフローモデルを1件保存する。
     */
    async saveWorkflowModel(requestParameters: SaveWorkflowModelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkflowModelEntity> {
        const response = await this.saveWorkflowModelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * expressionが正しいかを返します。
     */
    async validateExpressionRaw(requestParameters: ValidateExpressionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['expressionJson'] == null) {
            throw new runtime.RequiredError(
                'expressionJson',
                'Required parameter "expressionJson" was null or undefined when calling validateExpression().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/models/validate/{expressionJson}`.replace(`{${"expressionJson"}}`, encodeURIComponent(String(requestParameters['expressionJson']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * expressionが正しいかを返します。
     */
    async validateExpression(requestParameters: ValidateExpressionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.validateExpressionRaw(requestParameters, initOverrides);
    }

}
